module.exports = __webpack_public_path__ + "img/banner1.79f87c83.png";